module.exports = __webpack_public_path__ + "img/texas-caviar.98c65599.jpg";